<div class="card tw-p-2" *ngFor="let item of value;let i=index" style="background-color: rgba(100, 100, 100, 0.1);">
  <div class="p-fluid p-formgrid grid tw-flex-nowrap tw-items-end tw-m-0 tw-gap-2">
    <div class="field tw-flex-1">
      <label htmlFor="id">If Selected Option Is</label>
      <p-dropdown [options]="options" [(ngModel)]="item.MenuOptionId" optionLabel="Name" optionValue="Id"></p-dropdown>
    </div>
    <div class="field tw-flex-1">
      <label htmlFor="price">Default</label>
      <input pInputText id="price" type="number" [(ngModel)]="item.Price" />
    </div>
    <div class="field tw-flex-1">
      <label htmlFor="delivery-price">Delivery</label>
      <input pInputText id="delivery-price" type="number" [(ngModel)]="item.DeliveryPrice" />
    </div>
    <div class="field tw-flex-1">
      <label htmlFor="pickup-price">Takeaway</label>
      <input pInputText id="pickup-price" type="number" [(ngModel)]="item.PickupPrice" />
    </div>
    <div class="field tw-flex-1">
      <label htmlFor="dine-in-price">Dine In</label>
      <input pInputText id="dine-in-price" type="number" [(ngModel)]="item.DineInPrice" />
    </div>
    <div class="field">
      <p-button icon="pi pi-clone" severity="secondary" [text]="true" [rounded]="true" (click)="makePricesSame(item)"
        class="btn-min" title="Make row prices the same"></p-button>
    </div>
    <div class="field">
      <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" (click)="removeItem(i)" class="btn-min"></p-button>
    </div>
  </div>
</div>
<div class="tw-flex">
  <p-button label="Add new price" icon="pi pi-plus" (click)="addItem()"></p-button>
</div>
